import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { QaqcAnalysisController } from './qaqc-analysis.controller';
import { QaqcAnalysisService } from './qaqc-analysis.service';
import { QAQCFibreAnalysisEntity } from './entities/qaqc-fibre-analysis.entity';
import { QAQCFibreLabAnalysisEntity } from './entities/qaqc-fibre-lab-analysis.entity';
import { WorkOrderInfo } from '../work-order-generation/work-order.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ProductionInventory } from 'apps/services/production/src/app/operations-track/entities/production-inventory.entity';
import { QAQCProductCountsEntity } from './entities/qaqc-product-counts-entity';
@Module({
  imports: [
    TypeOrmModule.forFeature([
      QAQCFibreAnalysisEntity,
      QAQCFibreLabAnalysisEntity,
      WorkOrderInfo,
      ProductionInventory,
      QAQCProductCountsEntity
    ]),
  ],
  controllers: [QaqcAnalysisController],
  providers: [QaqcAnalysisService,ApplicationExceptionHandler],
  exports: [QaqcAnalysisService,ApplicationExceptionHandler],
})
export class QaqcModule {}
